<template>
  <div class="column">
    <q-editor :dense="$q.screen.lt.md"
              v-model="text" min-height="5rem" class="col-1" :definitions="{
        upload: {
          tip: 'Отправить комментарий',
          icon: 'cloud_upload',
          label: 'Отправить',
          disable: () => (text.trim().length < 10),
          handler: upload
        }
      }"
              :toolbar="[
        ['bold', 'italic', 'strike', 'underline'],
        ['link'],
        ['upload']
      ]"/>
    <q-file
        :max-files="4"
        clearable
        @rejected="onRejected"
        :max-total-size="1048576"
        class="q-my-sm"
        hint="Максимум 4 файла общим размером 10 МБ."
        v-model="attachments"
        label="Прикрепить файлы"
        filled
        multiple
    />
    <q-separator/>
    <q-infinite-scroll ref="scrollArea" :initial-index="-1" @load="load">
      <!--      <q-chat-message :stamp="dayJs.utc(comment.createdAt).local().fromNow()" v-for="comment in comments"
                            text-html
                            :text="[comment.text]" :name="comment.author.username"></q-chat-message>-->
      <q-card v-for="comment in comments" class="q-my-sm">
        <q-card-section horizontal class="items-center justify-between">
          <q-card-section>
            <b>{{ comment.author.username }}</b>
            добавил комментарий {{ dayJs.utc(comment.createdAt).local().fromNow() }}
          </q-card-section>
          <q-card-section v-if="comment.author.email === user.email">
            <q-btn icon="delete" flat size="10px" color="negative" @click="deleteComment(comment)"/>
            <q-btn icon="edit" flat size="10px" color="primary" @click="editComment = comment"/>
          </q-card-section>
        </q-card-section>

        <q-card-section v-if="editComment != comment" v-html="comment.text"/>
        <q-card-section v-else>
          <q-editor :dense="$q.screen.lt.md"
                    v-model="comment.text" min-height="5rem" class="col-1" :definitions="{
        edit: {
          tip: 'Изменить комментарий',
          icon: 'cloud_upload',
          label: 'Изменить',
          disable: () => (comment.text.trim().length < 10),
          handler: edit
        },
         cancelEdit: {
          tip: 'Отменить',
          icon: 'close',
          label: 'Отмена',
          handler: ( ) => editComment = null
        }
      }"
                    :toolbar="[
        ['bold', 'italic', 'strike', 'underline'],
        ['link'],
        ['edit', 'cancelEdit']
      ]"/>
        </q-card-section>
        <q-card-section>
          <q-item :href="`${apiUrl}/attachments/${attachment.address}`" target="_blank"
                  v-for="attachment in comment.attachments">
            <q-item-section avatar>
              <q-icon name="note"/>
            </q-item-section>
            <q-item-section>
              <q-item-label>{{ attachment.name }}</q-item-label>
              <q-item-label caption>{{ attachment.type }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-card-section>

      </q-card>
      <template v-slot:loading>
        <div class="row justify-center q-my-md">
          <q-spinner-dots color="primary" size="40px"/>
        </div>
      </template>
    </q-infinite-scroll>
  </div>
</template>

<script setup lang="ts">
import {useDayJs} from "../composables/dayjs";
import {useRoute} from "vue-router";
import {computed, ref, watch} from "vue";
import {useComments, useAddComments, useUpdateComments, useDeleteComments} from "../composables/comment";
import {Comment} from "../models/comment";
import {useQuasar} from "quasar";
import {QRejectedEntry} from "quasar/dist/types/api";
import {useUserStore} from "../store/user";
import {storeToRefs} from "pinia";

const apiUrl = import.meta.env.VITE_API_URL
const $q = useQuasar()
const dayJs = useDayJs()
const route = useRoute()

const userStore = useUserStore()

const {user} = storeToRefs(userStore)

const projectId = computed(() => Number(route.params.projectId))
const taskId = computed(() => Number(route.params.taskId))

const editComment = ref<Comment | null>(null)
const comments = ref<Comment[]>([])

const text = ref("")
const attachments = ref([])
const scrollArea = ref()
const data = ref(new FormData())

const {execute: executeAdd} = useAddComments(projectId, taskId, data)
const {execute: executeUpdate} = useUpdateComments(projectId, taskId, editComment)
const {execute: executeDelete} = useDeleteComments(projectId, taskId, editComment)

watch(taskId, () => {
  scrollArea.value.setIndex(-1)
  scrollArea.value.resume()
  scrollArea.value.trigger()
})
async function upload() {
  const uploadData = new FormData()

  uploadData.set('text', text.value)
  attachments.value.forEach(f => {
    uploadData.append('attachments', f)
  })

  data.value = uploadData

  await executeAdd(true)

  scrollArea.value.setIndex(-1)
  scrollArea.value.resume()
  scrollArea.value.trigger()
  text.value = ""
  attachments.value = []
}

async function edit() {
  await executeUpdate(true)
  scrollArea.value.setIndex(-1)
  scrollArea.value.resume()
  scrollArea.value.trigger()
}

async function deleteComment(comment: Comment) {
  $q.dialog({
    title: 'Удаление',
    message: 'Вы уверены что хотите удалить комментарий',
    cancel: true,
    persistent: true
  }).onOk(() => {
    editComment.value = comment
    executeDelete(true).then(() => editComment.value = null)
    scrollArea.value.setIndex(-1)
    scrollArea.value.resume()
    scrollArea.value.trigger()
  })

}

async function load(index: number, done: (stop?: boolean) => void) {
  if (index === 0) {
    comments.value = []
  }

  const {data} = await useComments(projectId, taskId, index)

  comments.value = comments.value.concat(data.value?.content ?? [])

  done(data.value?.last)

}


function onRejected(rejectedEntries: QRejectedEntry[]) {
  $q.notify({
    type: 'negative',
    message: `${rejectedEntries.length} файл(ов) не прошли валидацию`
  })
}
</script>

<style scoped>

</style>